import * as ActionTypes from "../actions/actionTypes";
import initialState from "./initialState";

export default (state = initialState.messages, action) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_MESSAGES_SNAPSHOT:
      return [...action.messages];
    case ActionTypes.PUSH_MESSAGE:
      return [...state, action.message];
    case ActionTypes.POP_MESSAGE: {
      let messages = [...state];
      messages.shift();
      return messages;
    }
    default:
      return state;
  }
};
